/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/28/2023
 */
import React, { useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from "@mui/material"
import NewPermissionsTransferList from "./NewPermissionsTransferList"
import api from "../../services/AuthApi"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import UserLevels from "./UserLevels"
import Alerts from "../../errorHandeling/Alerts"

const CreateNewRoleModal = ({
  open,
  onClose,
  setIsChange,
  setIsPendingChange,
}) => {
  const [data, setData] = useState([])
  const [permList, setPermList] = useState([])
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])
  const [isBtnLoading, setIsBtnLoading] = useState(false)

  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [iserrorShow, setIserrorShow] = useState(false)

  const handleClearData = () => {
    setIserrorShow(false)
    onClose()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)
    setIserrorShow(true)
    const obj = { ...data }
    obj.permissions = permList

    const payload = {
      rolePerms: [obj],
    }

    api
      .post("/role/permissions", payload)
      .then((res) => {
        setIsBtnLoading(false)
        setErrorMessages([])
        setIserror(false)
        setIserrorShow(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setIsChange(true)
        setIsPendingChange(true)
        setTimeout(() => {
          setIsSuccess(false)
          setSuccessMessages([""])
          onClose()
        }, 4000)
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsSuccess(false)

        setIserror(true)
        setErrorMessages([
          error.response.data.description
            ? error.response.data.description
            : "Role Creation Failed",
        ])
      })
  }

  const handleChange = (e) => {
    const value = e.target.value
    setData({
      ...data,
      [e.target.name]: value,
    })
    setIserror(false)
    setErrorMessages([])
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="true"
      open={open}
      PaperProps={{
        style: { borderRadius: "10px", width: "912px", margin: 0 },
      }}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#116c6f",
          color: "white",
          position: "fixed",
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "10px",
          width: "912px",
          zIndex: 1000,
        }}>
        Create New Role
        <IconButton
          aria-label="cancel"
          sx={{ color: "#fff" }}
          onClick={handleClearData}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent
          dividers
          sx={{
            marginTop: 8,
          }}>
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
            <TextField
              name="role"
              type="text"
              variant="outlined"
              color="secondary"
              label="Role"
              fullWidth
              required
              sx={{ mb: 4 }}
              onChange={handleChange}
            />
            <UserLevels data={data} handleChange={handleChange} />
          </Stack>
          <TextField
            name="desc"
            type="text"
            variant="outlined"
            color="secondary"
            label="Description"
            fullWidth
            required
            sx={{ mb: 4 }}
            onChange={handleChange}
          />
          <h6>Select Permissions</h6>
          <br />
          <br />

          <NewPermissionsTransferList setPermList={setPermList} />
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleClearData} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}>
            Create
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateNewRoleModal
